(() => {
  angular.module('app').component('hostPanelRecruitmentDashboardMonthlyStatsWidget', {
    templateUrl: require('./monthlyStats.component.html'),
    controller: MonthlyStatsComponentController,
    controllerAs: 'vm',
  });

  MonthlyStatsComponentController.$inject = [
    'abp.services.app.panelRecruitmentDashboard',
    'Hms.MultiTenancy.TenantClinicType',
  ];

  function MonthlyStatsComponentController(panelRecruitmentDashboardSvc, enumTenantClinicType) {
    function init() {
      loadData();
    }

    const vm = this;
    vm.loading = 0;
    vm.availableMonths = [];
    vm.countries = [];
    vm.subdivisions = [];
    vm.cities = [];
    vm.statistic = null;
    vm.filter = {
      monthYear: null,
      countryCode: null,
      countrySubdivisionId: null,
      panelType: null,
      city: null,
    };
    vm.getMonthlyStatistic = getMonthlyStatistic;
    vm.resetCityAndGetMonthlyStatistics = resetCityAndGetMonthlyStatistics;
    vm.resetSubdivisionAndGetMonthlyStatistics = resetSubdivisionAndGetMonthlyStatistics;

    vm.enums = {};
    vm.enums.tenantClinicType = enumTenantClinicType;

    vm.hasIndonesiaAndThailandRegionalExpansion = abp.setting.getBoolean(
      'Hms.Feature.IndonesiaAndThailandRegionalExpansion'
    );

    function loadData() {
      vm.loading += 1;
      panelRecruitmentDashboardSvc
        .getMonthlyStatisticFilter()
        .success((data) => {
          vm.availableMonths = data.monthYears;
          if (vm.hasIndonesiaAndThailandRegionalExpansion) {
            vm.countries = data.countries.sort((a, b) => a.name.localeCompare(b.name));
            vm.countrySubdivisions = data.countrySubdivisions;
          } else {
            vm.subdivisions = data.countrySubdivisions;
          }
          vm.cityStates = data.cityStates;

          vm.filter.monthYear = _.head(vm.availableMonths);
          getMonthlyStatistic();
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getMonthlyStatistic() {
      vm.loading += 1;
      panelRecruitmentDashboardSvc
        .getMonthlyStatisticAsync(vm.filter)
        .success((data) => {
          processCacheItem(data);
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function processCacheItem(cacheItem) {
      vm.statistic = cacheItem;

      if (vm.statistic.leadConversionRate) {
        vm.statistic.leadConversionRate.percentage = _.round(
          vm.statistic.leadConversionRate.percentage,
          2
        );
        vm.statistic.leadConversionRate.diff = _.round(vm.statistic.leadConversionRate.diff, 2);
      }

      _.each(cacheItem.requestStatusCounts, (item) => {
        item.percentageDiff = _.round(item.percentageDiff, 2);
        switch (item.status) {
          case 0:
            vm.statistic.monthlyInitiate = item;
            break;
          case 3:
            vm.statistic.monthlyRejected = item;
            break;
          case 6:
            vm.statistic.monthlyActivated = item;
            break;
          case 7:
            vm.statistic.monthlyDeactivated = item;
            break;
          default:
            break;
        }
      });

      vm.filter.monthYear = _.some(vm.availableMonths, (month) => month === cacheItem.monthYear)
        ? cacheItem.monthYear
        : vm.filter.monthYear;
    }

    function resetSubdivisionAndGetMonthlyStatistics() {
      vm.filter.countrySubdivisionId = null;
      vm.filter.city = null;
      vm.cities = [];
      if (vm.filter.countryCode) {
        vm.subdivisions = vm.countrySubdivisions.filter((countrySubdivision) =>
          countrySubdivision.value.includes(vm.filter.countryCode)
        );
        vm.subdivisions.sort((a, b) => a.name.localeCompare(b.name));
      } else {
        vm.subdivisions = [];
      }

      getMonthlyStatistic();
    }

    function resetCityAndGetMonthlyStatistics() {
      vm.filter.city = null;
      if (vm.filter.countrySubdivisionId) {
        vm.cities = _.map(
          _.filter(vm.cityStates, ['countrySubdivisionId', vm.filter.countrySubdivisionId]),
          'city'
        ).sort();
      } else {
        vm.cities = [];
      }

      getMonthlyStatistic();
    }

    init();
  }
})();
